import {SectionTitle} from "../../CummonComponents/SectionTitle/SectionTitle";
import {Container, InfoWrap, ItemHook, ItemImg, Text, List, ListItem, Wrap, TextWrap, SubTitle, Link} from "./styled";
import {ReadMore} from "../ReadMore/ReadMore";
import {ImageSwitcher} from "./ImageSwitcher/ImageSwitcher";
import {useImageUrl} from "../../../queries";

const getProductAnchor = (title) => {
    if (!title) return '';
    return title.toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');
};

const ProductListItem = ({product, index}) => {
    const productItem = product?.item;
    const imageUrl = useImageUrl(productItem?.cover);
    const anchor = getProductAnchor(productItem?.title);

    return (
        <ListItem>
            <Link href={`#${anchor}`} target='_self'>
                {imageUrl && <ItemImg src={imageUrl}/>}
                <ItemHook>
                    {index + 1}. {productItem?.title}
                </ItemHook>
            </Link>
        </ListItem>
    );
};

export const WhatIsData = ({data}) => {
    const products = data?.products || [];
    const contentImages = data?.content_images || [];

    const descriptionLines = data?.content_description?.split('\n').filter(line => line.trim()) || [];
    const readMoreLines = data?.content_description_read_more?.split('\n').filter(line => line.trim()) || [];

    return (
        <Container>
            <Wrap>
                <SectionTitle>{data?.content_header_title}</SectionTitle>
                <SubTitle>{data?.content_header_description}</SubTitle>
                <List>
                    {products.map((product, index) => (
                        <ProductListItem
                            key={product?.item?.id || index}
                            product={product}
                            index={index}
                        />
                    ))}
                </List>
                <InfoWrap>
                    <TextWrap>
                        {descriptionLines.map((line, index) => (
                            <Text key={index} dangerouslySetInnerHTML={{ __html: line.replace(/^–\s*/, '– ') }} />
                        ))}
                        {readMoreLines.length > 0 && (
                            <ReadMore>
                                {readMoreLines.map((line, index) => (
                                    <Text key={index}>{line}</Text>
                                ))}
                            </ReadMore>
                        )}
                    </TextWrap>
                    <ImageSwitcher images={contentImages}/>
                </InfoWrap>
            </Wrap>
        </Container>
    )
}
